import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {INPUT, SELECT, DATE, COLOR, COMBO_BOX} = FIELD_TYPE;
const fields: DataFormField[] = [
  {
    type: INPUT,
    label: "ID ",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "Mã vật tư",
    name: "code",
    rules: [{required: true, message: "Chưa nhập mã vật tư"}],
  },
  {
    type: INPUT,
    label: "Tên vật tư",
    name: "name",
    rules: [{required: true, message: "Chưa nhập tên vật tư"}],
  },
  {
    type: INPUT,
    label: "Đơn vị tính",
    name: "donViTinh",
    rules: [{required: true, message: "Chưa nhập đơn vị tính"}],
  },

  {
    type: INPUT,
    label: "Loại vật tư",
    name: "loaiVatTu",
    rules: [{required: true, message: "Chưa nhập tên loại vật tư"}],
  },
  {
    type: INPUT,
    label: "Vật liệu",
    name: "vatLieu",
  },
  {
    type: SELECT,
    label: "Giới tính",
    name: "gioiTinh",
    // rules: [{required: true, message: "Chưa nhập tên nhà cung cấp"}],
    options: [
      {
        value: 0,
        label: "Nam",
      },
      {
        value: 1,
        label: "Nữ",
      },
    ],
  },
  {
    type: INPUT,
    label: "Hãng sản xuất",
    name: "hangSanXuat",
    // rules: [{required: true, message: "Chưa nhập mô tả"}],
  },
  {
    type: INPUT,
    label: "Đặc điểm khác",
    name: "dacDiemKhac",
    // rules: [{required: true, message: "Chưa nhập tên nhà cung cấp"}],
  },
  {
    type: COMBO_BOX,
    label: "Kho quản lý",
    name: "storeDtos",
    mode: "multiple",
  },
  {
    type: INPUT,
    label: "Ghi chú",
    name: "ghiChu",
    // rules: [{required: true, message: "Chưa nhập mô tả"}],
  },
];
export {fields};
